import { InjectionToken } from '@angular/core';
import type { WorkflowPayload } from '../models/canonical.types';
import type { ExecutionTraceEntry, RunState } from '../models/run-state.types';

/** Persisted workflow run snapshot (definition loaded separately on hydrate). */
export type WorkflowRunStorageSnapshot = {
  instanceId: string;
  workflowKey: string;
  versionNumber: number;
  payload: WorkflowPayload;
  trace: ExecutionTraceEntry[];
  pausedNodeKey?: string;
  status: RunState['status'];
  error?: { code: string; message: string };
};

export abstract class WorkflowRunStorageAdapter {
  /** Persist a run snapshot. Implementations may write asynchronously. */
  abstract saveRun(snapshot: WorkflowRunStorageSnapshot): void;

  abstract getRun(instanceId: string): Promise<WorkflowRunStorageSnapshot | null>;

  abstract getActiveInstanceId(workflowKey: string): Promise<string | null>;

  /** Fallback when the active pointer is missing or stale. */
  abstract listInstanceIdsForWorkflow(workflowKey: string): Promise<string[]>;
}

export const WORKFLOW_RUN_STORAGE = new InjectionToken<WorkflowRunStorageAdapter>(
  'WORKFLOW_RUN_STORAGE',
);
